import { ChangeDetectionStrategy, Component, OnInit, Inject, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUploadService } from '../../fileUpload/file-upload/file-upload.service';
import { ImportDiaologTableService } from '../import-dialog-table/import-dialog-table.service';

export interface DialogData {
  fileData: string[];
  columnData: any;
  sourceName: string;
}

@Component({
  selector: 'dl-import-dialog-file',
  templateUrl: './import-dialog-file.component.html',
  styleUrls: ['./import-dialog-file.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [FileUploadService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportDialogFileComponent implements OnInit {
  public filename = new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*')]);

  public importButton = true;
  public getImportData: Observable<string>;
  public checkdropdownFlag: string;
  public constructor(private fileuploadService: FileUploadService, private importDiaologTableService: ImportDiaologTableService, private readonly dialog: MatDialog, public dialogRef: MatDialogRef<ImportDialogFileComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  public ngOnInit(): void {
    this.getImportData = this.onImportbtnCheckData();
    this.filename.valueChanges.subscribe(x => {
      if (this.checkdropdownFlag === 'Import button Active' && this.filename.valid) {
        this.importButton = false;
        this.data.sourceName = this.filename.value;
        // console.log('import-dialog-file:---***',this.data.sourceName);
      } else {
        this.importButton = true;
        return this.filename.markAsDirty();
      }
    });
  }

  public onImportbtnCheckData(): Observable<string> {
    this.fileuploadService.checkValidDataobservable$.subscribe(d => {
      this.checkdropdownFlag = d;
      if (d === 'Import button Active' && this.filename.valid) {
        this.importButton = false;
        this.data.sourceName = this.filename.value;
        // console.log('import-dialog-file:---***',this.data.sourceName);
      } else {
        this.importButton = true;
      }
    });
    return;
  }

  public onFileUpload(evt: any): void {
    if (evt !== undefined) {
      let filenameOnupload, filenameOnuploadValid: string;
      if (evt.fileDetails.name) {
        filenameOnupload = evt.fileDetails.name.split('.')[0];
        filenameOnuploadValid = filenameOnupload.replace(/[^a-zA-Z ]/g, '');
        if (filenameOnuploadValid.length > 25) {
          filenameOnuploadValid = filenameOnuploadValid.slice(0, 25);
        }
      }
      evt.fileDetails.name ? this.filename.setValue(filenameOnuploadValid) : this.filename.setValue('');
      this.fileuploadService.sheetToJsonDataobservable$.subscribe(d => {
        this.data.fileData = d;
      });
      this.importDiaologTableService.mappingData$.subscribe(impData => {
        this.data.columnData = impData;
      });
      this.data.sourceName = this.filename.value;
    }
  }
}
